(ns app.front.ui.phrase
  (:require [app.front.ui :as ui]
            [app.front.ui.blip :as ui-blip]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::phrase-data :-> ::phrase-data)


(rf/reg-sub ::selected-category
  :<- [::phrase-data]
  :-> :selected-category)


(rf/reg-event-db ::set-selected-category
  (fn [db [_ category]]
    (assoc-in db [::phrase-data :selected-category] category)))


(rf/reg-sub ::search-text
  :<- [::phrase-data]
  :-> :search-text)


(rf/reg-event-db ::set-search-text
  (fn [db [_ text]]
    (assoc-in db [::phrase-data :search-text] text)))


(rf/reg-event-db ::clear-search-text
  (fn [db _]
    (p/dissoc-in db [::phrase-data :search-text])))


(defn phrase-has-category? [category phrase]
  (or (nil? category)
      (= (-> phrase :phrase/category :db/id)
         (:db/id category))))


(defn phrase-matches? [search-text {:phrase/keys [name text]}]
  (or (util/nil-or-blank? search-text)
      (str/includes? (str/upper-case name) (str/upper-case search-text))
      (str/includes? (str/upper-case text) (str/upper-case search-text))))


(rf/reg-sub ::applicable-phrases
  :<- [::selected-category]
  :<- [::search-text]
  (fn [[category search-text] [_ phrases]]
    (->> phrases
         (filter (partial phrase-has-category? category))
         (filter (partial phrase-matches? search-text))
         (sort-by :phrase/name))))


(defn phrase-row-data [tr {:phrase/keys [name text] :as phrase} on-change rt-editor]
  [:li.p-2.bg-ui-light-gray.my-2.gap-4.rounded
   [:div.flex.items-center.justify-between
    [:div.flex.flex-col.max-w-3xl
     [:div.text-base.font-bold name]
     [rt-editor {:id            (str "phrase-" (:db/id phrase))
                 :initial-value text}]]
    [ui-blip/blip
     (fn [show-blip]
       (cc/button {:kind     :ghost
                   :on-click (fn []
                               (on-change text)
                               (show-blip (tr [:phrase/added])))}
                  (tr [:add])))]]])


(defn phrase-selector [{:keys [tr phrases on-change rt-editor]}]
  (let [selected-category  (<sub [::selected-category])
        search-text        (<sub [::search-text])
        applicable-phrases (<sub [::applicable-phrases phrases])]
    (when (seq phrases)
      [:div
       [:div.flex.flex-wrap.bg-ui-light-gray.p-5.mb-5.gap-4.rounded
        [:div.flex-1 {:style {:min-width "300px"}}
         [ui-select/select {:id           "category-select"
                            :class-name   "full-width-select"
                            :light        true
                            :allow-empty? true
                            :empty-text   (tr [:phrase.category/all])
                            :select-text  (tr [:phrase.category/name])
                            :values       (->> phrases
                                               (map :phrase/category)
                                               distinct
                                               (sort-by :phrase.category/name))
                            :val->str     :phrase.category/name
                            :value        selected-category
                            :on-change    #(>evt [::set-selected-category %])}]]
        [:div.flex-1 {:style {:min-width "300px"}}
         [ui/search {:id                      "phrase-search"
                     :label-text              (tr [:dashboard-search/search])
                     :close-button-label-text (tr [:search/empty])
                     :light                   true
                     :size                    :medium
                     :value                   search-text
                     :on-change               #(rf/dispatch-sync [::set-search-text (futil/tval %)])
                     :clear-fn                #(>evt [::clear-search-text])}]]]
       [:ul.border-t.border-b.border-solid.border-ui-gray
        (futil/for-frag [phrase applicable-phrases]
          (phrase-row-data tr phrase on-change rt-editor))]])))
